var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFooterFixedX = function SvgIconFooterFixedX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.667 8.42 1.19 1.451h4.338L8.91 5.758l3.612-4.286h2.389L10.064 7.23l5.746 7.319h-4.325l-3.66-4.657-3.909 4.644H1.514zm5.448 4.838L3.85 2.743h1.047l8.255 10.515z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFooterFixedX;